import About from './components/About';
import Works from './components/Works';
import Socials from './components/Socials';
import {
    Routes,
    Route,
    useLocation
} from "react-router-dom";

import { AnimatePresence, motion } from 'framer-motion';

function AnimatedRoutes({ theme, setTheme }) {
    const location = useLocation();
    return (
        <AnimatePresence exitBeforeEnter>
            <Routes key={location.pathname} location={location}>
                <Route path='/' element={<About motion={motion} />} />
                <Route path='/about' element={<About motion={motion} />} />
                <Route path='/works' element={<Works motion={motion} />} />
                <Route path='/socials' element={<Socials motion={motion} />} />
            </Routes>
        </AnimatePresence>
    )
}

export default AnimatedRoutes